import React from "react"
import core1 from "../../assets/images/about/core1.svg"
import core2 from "../../assets/images/about/core2.svg"
import core3 from "../../assets/images/about/core3.svg"

const CoreValues = () => {
  return (
    <div className="row core-value-area">
      <div className="col">
        <h3 className="heading-2">Our Core Values</h3>
        <div className="core-value-wrapper">
          <div className="core-value">
            <img src={core1} alt="core value icon" />
            <div>
              {" "}
              <h5 className="core-value-title">Performance</h5>
              <p className="paragraph-3">
                We get you the fastest approval that's possible. Applying is
                <span className="text-dec"> simple, fast & free.</span> It wont effect your credit score either.
              </p>
            </div>
          </div>
          <div className="core-value">
            <img src={core2} alt="core value icon" />
            <div>
              <h5 className="core-value-title">Integrity</h5>
              <p className="paragraph-3">
                We stand behind our loans. We will only offer products that are
                suitable for you.
              </p>
            </div>
          </div>
          <div className="core-value">
            <img src={core3} alt="core value icon" />
            <div>
              <h5 className="core-value-title">Quality</h5>
              <p className="paragraph-3">
                Our products are high quality - the same as you would find at
                your bank.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CoreValues
